(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-carousel-section").forEach(section => {

    const carousel = section.querySelector(".collection-carousel");
    const prev = section.querySelector(".prev");
    const next = section.querySelector(".next");

    const desktop = parseInt(section.dataset.desktop);
    const tablet = parseInt(section.dataset.tablet);
    const mobile = parseInt(section.dataset.mobile);

    let originals = [];
    let items = [];
    let per = 1;
    let index = 0;
    let step = 0;

    function perView() {
      if (window.innerWidth <= 990) return mobile;
      if (window.innerWidth <= 1200) return tablet;
      return desktop;
    }

    function setup() {
      carousel.querySelectorAll(".is-clone").forEach(el => el.remove());
      originals = Array.from(carousel.children);
      per = perView();

      originals.slice(-per).forEach(el => {
        const clone = el.cloneNode(true);
        clone.classList.add("is-clone");
        carousel.prepend(clone);
      });

      originals.slice(0, per).forEach(el => {
        const clone = el.cloneNode(true);
        clone.classList.add("is-clone");
        carousel.append(clone);
      });

      items = Array.from(carousel.children);
      index = per;

      updateSizes();
      jump();
    }

    function updateSizes() {
      const wrapperWidth = carousel.parentElement.offsetWidth;
      const gap = parseFloat(getComputedStyle(carousel).gap) || 0;
      const itemWidth = (wrapperWidth - gap * (per - 1)) / per;
      items.forEach(el => el.style.flex = `0 0 ${itemWidth}px`);
      step = itemWidth + gap;
    }

    function move() {
      carousel.style.transition = "transform 0.45s ease";
      carousel.style.transform = `translateX(-${index * step}px)`;
    }

    function jump() {
      carousel.style.transition = "none";
      carousel.style.transform = `translateX(-${index * step}px)`;
      carousel.offsetHeight;
      carousel.style.transition = "transform 0.45s ease";
    }

    next.addEventListener("click", () => { index++; move(); });
    prev.addEventListener("click", () => { index--; move(); });

    carousel.addEventListener("transitionend", () => {
      if (index >= originals.length + per) { index = per; jump(); }
      if (index < per) { index = originals.length + per - 1; jump(); }
    });

    let auto = setInterval(() => { index++; move(); }, 3500);

    section.addEventListener("mouseenter", () => clearInterval(auto));
    section.addEventListener("mouseleave", () => {
      auto = setInterval(() => { index++; move(); }, 3500);
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 150);
    });

    setup();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
  
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
  
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('product-recommendations');
  
              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;
              }
  
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
              if (window.SPR && theme.review ) {
                if ($('.shopify-product-reviews-badge').length > 0) {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                };
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
  
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
      }
    }
  
    customElements.define('product-recommendations', ProductRecommendations);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonios-disenados"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".testimonial-section").forEach(section => {
    const wrapper = section.querySelector(".testimonial-slider-wrapper");
    const slider = wrapper.querySelector(".testimonial-slider");
    const cards = wrapper.querySelectorAll(".testimonial-card");
    const prev = section.querySelector(".prev");
    const next = section.querySelector(".next");
    const btnWrapper = section.querySelector('.testimonial-btn-wrapper');
    const gap = parseInt(getComputedStyle(slider).gap) || 20;
    let perView = 3;
    let index = 0;

    function updatePerView() {
      if (window.innerWidth <= 600) perView = 1;
      else if (window.innerWidth <= 990) perView = 2;
      else perView = 3;
    }

    function setWidths() {
      updatePerView();
      const wrapperWidth = wrapper.offsetWidth;
      const totalGap = gap * (perView - 1);
      const cardWidth = (wrapperWidth - totalGap) / perView;

      cards.forEach(card => card.style.flex = `0 0 ${cardWidth}px`);

      // Flechas desktop
      if (cards.length > perView) {
        prev.style.display = 'flex';
        next.style.display = 'flex';
      } else {
        prev.style.display = 'none';
        next.style.display = 'none';
      }

      // Flechas móviles
      if (cards.length > perView) btnWrapper.style.display = 'flex';
      else btnWrapper.style.display = 'none';
    }

    function moveSlider() {
      const cardWidth = cards[0].offsetWidth + gap;
      const maxIndex = cards.length - perView;

      if (index < 0) index = maxIndex;
      if (index > maxIndex) index = 0;

      slider.style.transform = `translateX(-${index * cardWidth}px)`;
    }

    next.addEventListener('click', () => { index++; moveSlider(); });
    prev.addEventListener('click', () => { index--; moveSlider(); });

    window.addEventListener('resize', () => { setWidths(); moveSlider(); });

    setWidths();
    moveSlider();
  });
});

  } catch(e) { console.error(e); }
})();
})();
